import { LineReveal } from "./Reveal";

// Consistent interior-page header with numbered label + masked title.
export const PageIntro = ({ label, titleLines, blurb }) => (
  <section className="mx-auto max-w-[1600px] px-5 pb-16 pt-32 md:px-10 md:pb-24 md:pt-44">
    <div className="mb-8 flex items-center gap-4">
      <span className="text-xs uppercase tracking-[0.25em] text-terracotta">{label}</span>
      <span className="h-px flex-1 bg-ink/30" />
    </div>
    <h1 className="text-[13vw] font-medium uppercase leading-[0.85] tracking-tighter md:text-[8vw]">
      <LineReveal lines={titleLines} animate="immediate" baseDelay={0.1} />
    </h1>
    {blurb && (
      <p className="mt-8 max-w-xl text-lg font-normal leading-relaxed md:text-xl">{blurb}</p>
    )}
  </section>
);
